import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Modal from '../shared/Modal.svelte';
import { getActiveChildren, getActiveChild, setActiveChild } from '../../lib/stores/children.svelte.ts';
import { navigate } from '../../lib/router.svelte.ts';

var root_1 = $.from_html(`<button class="switcher svelte-10058admhhqnq" aria-haspopup="dialog"><span class="dot" aria-hidden="true">👶</span> <span class="name svelte-10058admhhqnq"> </span> <span class="caret svelte-10058admhhqnq" aria-hidden="true">▾</span></button>`);
var root_4 = $.from_html(`<span class="check svelte-10058admhhqnq" aria-label="active">✓</span>`);
var root_3 = $.from_html(`<li><button class="row svelte-10058admhhqnq"><span class="row-name svelte-10058admhhqnq"> </span> <span class="row-age svelte-10058admhhqnq"> </span> <!></button></li>`);
var root_2 = $.from_html(`<ul class="list svelte-10058admhhqnq"></ul> <div class="footer svelte-10058admhhqnq"><button class="footer-btn svelte-10058admhhqnq">+ Add child</button> <button class="footer-btn svelte-10058admhhqnq">Manage children</button></div>`, 1);
var root = $.from_html(`<!> <!>`, 1);

function ChildSwitcher($$anchor, $$props) {
	$.push($$props, true);

	let open = $.state(false);
	const children = $.derived(getActiveChildren);
	const active = $.derived(getActiveChild);

	function ageLabel(dob) {
		const ms = Date.now() - dob;
		const days = Math.floor(ms / (24 * 60 * 60 * 1000));

		if (days < 30) return `${days} day${days === 1 ? '' : 's'} old`;

		const months = Math.floor(days / 30);

		if (months < 24) return `${months} month${months === 1 ? '' : 's'} old`;

		const years = Math.floor(months / 12);

		return `${years} year${years === 1 ? '' : 's'} old`;
	}

	async function pick(id) {
		await setActiveChild(id);
		$.set(open, false);
	}

	function manage() {
		$.set(open, false);
		navigate('/more/children');
	}

	function add() {
		$.set(open, false);
		navigate('/profile/new');
	}

	var fragment = root();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var button = root_1();
			var span = $.sibling($.child(button), 2);
			var text = $.child(span, true);

			$.reset(span);
			$.next(2);
			$.reset(button);
			$.template_effect(() => $.set_text(text, $.get(active).name));
			$.delegated('click', button, () => $.set(open, true));
			$.append($$anchor, button);
		};

		$.if(node, ($$render) => {
			if ($.get(children).length > 1 && $.get(active)) $$render(consequent);
		});
	}

	var node_1 = $.sibling(node, 2);

	Modal(node_1, {
		get open() {
			return $.get(open);
		},
		onclose: () => $.set(open, false),
		title: 'Switch child',
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = root_2();
			var ul = $.first_child(fragment_1);

			$.each(ul, 21, () => $.get(children), (c) => c.id, ($$anchor, c) => {
				var li = root_3();
				var button_1 = $.child(li);
				var span_1 = $.child(button_1);
				var text_1 = $.child(span_1, true);

				$.reset(span_1);

				var span_2 = $.sibling(span_1, 2);
				var text_2 = $.child(span_2, true);

				$.reset(span_2);

				var node_2 = $.sibling(span_2, 2);

				{
					var consequent_1 = ($$anchor) => {
						var span_3 = root_4();

						$.append($$anchor, span_3);
					};

					$.if(node_2, ($$render) => {
						if ($.get(active)?.id === $.get(c).id) $$render(consequent_1);
					});
				}

				$.reset(button_1);
				$.reset(li);

				$.template_effect(
					($0) => {
						$.set_text(text_1, $.get(c).name);
						$.set_text(text_2, $0);
					},
					[() => ageLabel($.get(c).dateOfBirth)]
				);

				$.delegated('click', button_1, () => pick($.get(c).id));
				$.append($$anchor, li);
			});

			$.reset(ul);

			var div = $.sibling(ul, 2);
			var button_2 = $.child(div);
			var button_3 = $.sibling(button_2, 2);

			$.reset(div);
			$.delegated('click', button_2, add);
			$.delegated('click', button_3, manage);
			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	ChildSwitcher = $.hmr(ChildSwitcher);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-10058admhhqnq');
		ChildSwitcher[$.HMR].update(module.default);
	});
}

export default ChildSwitcher;

$.delegate(['click']);
import "bun-svelte:ChildSwitcher.svelte-2425a12gnetaa-style.css";